
import {gql} from "apollo-angular";

export const get_states = gql`
  query getStates{
    states{
      id
      name
      abbreviation
    }
  }
  `
